import { classes, st } from './DraggableContainer.st.css.js';
import { useContext } from 'react';
import { WixDesignSystemContext } from '../WixDesignSystemProvider/context';
export function useDraggableContainer(props) {
    const { draggable, dragging, dragDisabled, dim, highlight } = props;
    const { newColorsBranding } = useContext(WixDesignSystemContext);
    return {
        className: st(classes.root, {
            newColorsBranding,
            draggable,
            dragging,
            dragDisabled,
            dim,
            highlight,
        }),
    };
}
//# sourceMappingURL=useDraggableContainer.js.map